import type {MessagesType} from 'src/lib/translates/types'
import {getTranslates} from 'src/lib/translates/getTranslates'
import {APIServiceTranslates, type GetMessagesParamsType} from './entities';

class LocalAPIServiceTranslates implements APIServiceTranslates {

  public init() {
  }

  public getTranslates = async (params: GetMessagesParamsType): Promise<MessagesType> => {        
    return Promise.resolve(getTranslates(params.lang));
  }
}

export const localAPIServiceTranslates = new LocalAPIServiceTranslates();
